module.exports = ".download-file-link {\n  text-align: left;\n  margin-bottom: 10px; }\n  .download-file-link .label {\n    font-weight: bold;\n    color: black;\n    font-size: 14px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/+campaign-library/email-modal/asset-email.scss
// module id = ./src/app/+campaign-library/email-modal/asset-email.scss
// module chunks = main